// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { carouselStyles } from "@sc/Overrides/Components/ProductCompareCarousel";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

carouselStyles.attributeWrapper = {
    css: css`
        margin-top: 40px;
        width: 100%;
        max-width: 100%;
    `,
};

carouselStyles.attributeContainer = {
    css: css`
        width: 100%;
        max-width: 100%;
        border-radius: 4px;
        background-color: ${color("common.white")};
        box-shadow: 0 0 9px 0 ${color("common.ui5", 0.15)};
        margin-bottom: 16px;
    `,
};

carouselStyles.attributeLabel = {
    as: "p",
    size: 15,
    weight: "bold",
    css: css`
        letter-spacing: 0;
        line-height: 20px;
        padding: 10px 10px 10px 15px;
        background: ${color("common.ui2")};
        min-height: 36px;
        &.first-item {
            border-radius: 4px 4px 0 0;
        }
    `,
};

carouselStyles.attributeValue = {
    as: "p",
    size: 15,
    css: css`
        letter-spacing: 0;
        line-height: 20px;
        text-align: center;
        min-height: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};

carouselStyles.carouselCellGridItem = {
    width: 12,
    css: css`
        &&&& {
            flex-basis: 100%;
            max-width: 100%;
            margin: 0 auto;

            .swiper-slide {
                // to make all slider same height
                height: auto;
                // To fix swiper render issue
                margin-top: 1px;
                margin-bottom: 1px;
                margin-left: 1px;
                max-width: 321px;
                min-width: 321px;
                ${xScreen("lt", "md")} {
                    max-width: 50%;
                }

                ${xScreen("lte", "xs")} {
                    max-width: 100%;
                }
            }
        }
    `,
};
